import { Theme } from "@emotion/react";
import { mdsCommonTheme } from "../common";

export const mdsThemeHarvestMoon: Theme = {
  ...mdsCommonTheme,

  colors: {
    ...mdsCommonTheme.colors,

    text: {
      contrast: mdsCommonTheme.colors.inkDark[700],
      primary: mdsCommonTheme.colors.graphiteDark[900],
      secondary: mdsCommonTheme.colors.graphiteDark[800],
      tertiary: mdsCommonTheme.colors.inkDark[600],
      onAccent: mdsCommonTheme.colors.inkDark[0],
      emphasis: mdsCommonTheme.colors.blueprint[300],
      positive: mdsCommonTheme.colors.success,
      danger: mdsCommonTheme.colors.editorDark[400],
      link: {
        default: mdsCommonTheme.colors.blueprint[400],
        hover: mdsCommonTheme.colors.blueprint[300],
      },
      editor: {
        metadata: mdsCommonTheme.colors.graphite[800], // TODO: Not in Figma
      },
    },
    icon: {
      primary: mdsCommonTheme.colors.graphiteDark[800],
      secondary: mdsCommonTheme.colors.graphiteDark[700],
      placeholder: mdsCommonTheme.colors.inkDark[600],
      onAccent: mdsCommonTheme.colors.graphiteDark[0],
      brand: mdsCommonTheme.colors.editor[300],
      selected: mdsCommonTheme.colors.blueprint[300],
      emphasis: mdsCommonTheme.colors.blueprint[300],
      danger: mdsCommonTheme.colors.editorDark[400],
      positive: mdsCommonTheme.colors.success, // TODO: Not in Figma
      onChromeInactive: mdsCommonTheme.colors.inkDark[500],
    },
    surface: {
      chrome: mdsCommonTheme.colors.inkDark[150],
      pane: mdsCommonTheme.colors.inkDark[0],
      paneHeader: mdsCommonTheme.colors.inkDark[50],
      chat: mdsCommonTheme.colors.inkDark[100],
      menu: mdsCommonTheme.colors.inkDark[50],
      modal: mdsCommonTheme.colors.inkDark[50],
      popover: mdsCommonTheme.colors.inkDark[50],
      preview: mdsCommonTheme.colors.inkDark[50],
      previewHeader: mdsCommonTheme.colors.inkDark[200],
      tooltip: mdsCommonTheme.colors.inkDark[700],
      onboarding: mdsCommonTheme.colors.inkDark[150],
      onboardingSubtle: mdsCommonTheme.colors.inkDark[100],
      headsUp: {
        default: mdsCommonTheme.colors.inkDark[50],
        hover: mdsCommonTheme.colors.inkDark[100],
      },
      toast: {
        default: mdsCommonTheme.colors.inkDark[50],
        danger: mdsCommonTheme.colors.editorDark[0],
      },
      overlay: {
        default: "rgba(0, 0, 0, 0.5)",
        onboarding: mdsCommonTheme.colors.transparentInk,
      },
    },
    border: {
      default: mdsCommonTheme.colors.inkDark[200],
      onAccent: mdsCommonTheme.colors.inkDark[300],
      ghost: mdsCommonTheme.colors.inkDark[0],
      surface: mdsCommonTheme.colors.inkDark[100],
      emphasis: mdsCommonTheme.colors.blueprint[300],
      chrome: mdsCommonTheme.colors.inkDark[150],
      input: {
        default: {
          default: mdsCommonTheme.colors.inkDark[400],
          focused: mdsCommonTheme.colors.inkDark[500],
          danger: mdsCommonTheme.colors.editorDark[400],
        },
        brand: {
          default: mdsCommonTheme.colors.transparent.default,
          focused: mdsCommonTheme.colors.editor[300],
        },
        emphasis: {
          default: mdsCommonTheme.colors.inkDark[400],
          focused: mdsCommonTheme.colors.blueprint[200],
        },
      },
      button: {
        marketing: {
          default: mdsCommonTheme.colors.inkDark[700],
          hover: mdsCommonTheme.colors.editor[300],
        },
      },
    },
    background: {
      activeTab: mdsCommonTheme.colors.blueprint[300],
      diff: mdsCommonTheme.colors.blueprintDark[0],
      codeBlock: mdsCommonTheme.colors.inkDark[600],
      textHighlight: mdsCommonTheme.colors.blueprintDark[300],
      findHighlight: "rgba(251, 204, 126, 0.4)",
      findHighlightCurrent: "rgba(251, 204, 126, 0.7)",
      inlineCode: mdsCommonTheme.colors.inkDark[200],
      list: {
        default: mdsCommonTheme.colors.inkDark[0],
        hover: mdsCommonTheme.colors.inkDark[50],
        selected: mdsCommonTheme.colors.inkDark[100],
        deepsearch: mdsCommonTheme.colors.blueprintDark[100],
        uploading: mdsCommonTheme.colors.inkDark[200],
        pending: mdsCommonTheme.colors.blueprintDark[100],
        error: mdsCommonTheme.colors.editorDark[0],
      },
      menu: {
        default: mdsCommonTheme.colors.inkDark[50],
        hover: mdsCommonTheme.colors.inkDark[100],
        selected: mdsCommonTheme.colors.inkDark[200],
        emphasized: mdsCommonTheme.colors.blueprintDark[0],
      },
      input: {
        default: {
          default: mdsCommonTheme.colors.inkDark[0],
          focused: mdsCommonTheme.colors.inkDark[100],
        },
        inline: {
          default: mdsCommonTheme.colors.transparent.default,
          hover: mdsCommonTheme.colors.inkDark[200],
          focused: mdsCommonTheme.colors.inkDark[200],
        },
        chrome: {
          default: mdsCommonTheme.colors.inkDark[50],
          focused: mdsCommonTheme.colors.inkDark[100],
          hover: mdsCommonTheme.colors.inkDark[100], // TODO: Not in Figma
        },
        onAccent: {
          default: mdsCommonTheme.colors.inkDark[200],
          focused: mdsCommonTheme.colors.inkDark[50],
        },
      },
      message: {
        user: mdsCommonTheme.colors.inkDark[50],
        mem: mdsCommonTheme.colors.transparent.default,
      },
      badge: {
        default: mdsCommonTheme.colors.inkDark[200],
        emphasis: mdsCommonTheme.colors.blueprintDark[200],
        moreEmphasis: mdsCommonTheme.colors.blueprintDark[300],
        notification: mdsCommonTheme.colors.editorDark[300],
        danger: mdsCommonTheme.colors.editorDark[0],
      },
      banner: {
        danger: mdsCommonTheme.colors.editorDark[0],
        emphasis: mdsCommonTheme.colors.blueprintDark[100],
        default: mdsCommonTheme.colors.inkDark[200],
      },
      card: {
        emphasis: mdsCommonTheme.colors.blueprintDark[200],
        default: mdsCommonTheme.colors.inkDark[100],
      },
      illustration: {
        default: mdsCommonTheme.colors.inkDark[300],
        onAccent: mdsCommonTheme.colors.inkDark[300],
        contrast: mdsCommonTheme.colors.inkDark[0],
      },
      voice: {
        self: mdsCommonTheme.colors.inkDark[100],
        others: mdsCommonTheme.colors.inkDark[150],
      },
      hoverOverlay: {
        default: mdsCommonTheme.colors.transparent["ink-dark-500-at-40po"],
        chrome: mdsCommonTheme.colors.transparent["ink-dark-100-at-30po"],
        "chrome-2": mdsCommonTheme.colors.transparent["ink-dark-500-at-40po"],
        negative: mdsCommonTheme.colors.transparent["editor-dark-400-at-15po"],
        emphasis: mdsCommonTheme.colors.transparent["blueprint-dark-400-at-60po"],
      },
      button: {
        default: {
          default: mdsCommonTheme.colors.inkDark[150], // TODO: Not in Figma
          hover: mdsCommonTheme.colors.inkDark[200], // TODO: Not in Figma
        },
        contrast: {
          default: mdsCommonTheme.colors.graphiteDark[900],
          hover: mdsCommonTheme.colors.graphiteDark[800],
        },
        chip: {
          default: mdsCommonTheme.colors.inkDark[150],
          hover: mdsCommonTheme.colors.inkDark[200],
          selectedNegative: mdsCommonTheme.colors.editorDark[0],
          selectedPositive: mdsCommonTheme.colors.paper,
        },
        toggle: {
          default: mdsCommonTheme.colors.inkDark[150],
          hover: mdsCommonTheme.colors.inkDark[200],
          toggled: mdsCommonTheme.colors.blueprintDark[100],
          toggledHover: mdsCommonTheme.colors.blueprintDark[200],
        },
        contrastAccent: {
          default: mdsCommonTheme.colors.inkDark[0],
          hover: mdsCommonTheme.colors.inkDark[50],
        },
        emphasis: {
          default: mdsCommonTheme.colors.blueprint[300],
          hover: mdsCommonTheme.colors.blueprint[400],
        },
        transparent: {
          default: mdsCommonTheme.colors.transparent.default,
          hover: mdsCommonTheme.colors.inkDark[200],
        },
        navigation: {
          default: mdsCommonTheme.colors.inkDark[150],
          hover: mdsCommonTheme.colors.inkDark[100],
        },
        chrome: {
          default: mdsCommonTheme.colors.inkDark[100],
          hover: mdsCommonTheme.colors.inkDark[100],
        },
        subtle: {
          default: mdsCommonTheme.colors.inkDark[50],
          hover: mdsCommonTheme.colors.inkDark[100],
        },
        danger: {
          default: mdsCommonTheme.colors.transparent.default,
          hover: mdsCommonTheme.colors.editorDark[0],
        },
        tabBar: {
          default: mdsCommonTheme.colors.inkDark[50],
          hover: mdsCommonTheme.colors.inkDark[100],
          active: mdsCommonTheme.colors.inkDark[0],
        },
        onChrome: {
          default: mdsCommonTheme.colors.transparent.default,
          hover: mdsCommonTheme.colors.inkDark[200],
        },
        onAccent: {
          default: mdsCommonTheme.colors.transparent.default,
          hover: mdsCommonTheme.colors.inkDark[300],
        },
        brand: {
          default: mdsCommonTheme.colors.editor[300],
          hover: mdsCommonTheme.colors.editor[200],
        },
        emphasisLight: {
          default: mdsCommonTheme.colors.blueprintDark[200],
          hover: mdsCommonTheme.colors.blueprintDark[300],
        },
        contextChipFromUser: {
          default: mdsCommonTheme.colors.inkDark[150],
          hover: mdsCommonTheme.colors.inkDark[200],
        },
        dangerFilled: {
          default: mdsCommonTheme.colors.editorDark[0],
          hover: mdsCommonTheme.colors.editorDark[100],
        },
        contextChipFromMem: {
          default: mdsCommonTheme.colors.inkDark[50],
          hover: mdsCommonTheme.colors.inkDark[150],
        },
        floatingIcon: {
          default: mdsCommonTheme.colors.inkDark[0],
          hover: mdsCommonTheme.colors.inkDark[100],
        },
      },
      toolbar: mdsCommonTheme.colors.transparentInkDark,
      skeleton: {
        start: mdsCommonTheme.colors.inkDark[300],
        middle: mdsCommonTheme.colors.inkDark[100],
        end: mdsCommonTheme.colors.inkDark[300],
      },
    },
  },

  shadows: {
    ...mdsCommonTheme.shadows,
    surface: "0 4px 6px 0 rgba(17, 17, 26, 0.75)",
    tabScrollButtonRight: "-4px 0 6px 0 rgba(17, 17, 26, 0.75)", // TODO: Not in Figma
    tabScrollButtonLeft: "4px 0 6px 0 rgba(17, 17, 26, 0.75)", // TODO: Not in Figma
  },
};
